import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const ASSETS = {
  logo: "/logo-icon.png",
  texture: "https://images.pexels.com/photos/7605642/pexels-photo-7605642.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  studio: "https://images.pexels.com/photos/6628520/pexels-photo-6628520.jpeg",
};

export const STUDIO = {
  name: "Dott.ssa Chiara Maiolo",
  domain: "psicologachiaramaiolo.it",
  address: "Via Giacomo Bosio 3",
  city: "Chivasso (TO)",
  phone: "348 856 5422",
  phoneRaw: "+393488565422",
  email: "chiaramaiolo.psicologa@gmail.com",
  vat: "13362140017",
};

export const SERVICES = [
  {
    key: "psicologia",
    title: "Psicologia",
    desc: "La psicologia è uno strumento fondamentale per comprendere a fondo le proprie dinamiche interiori, superare momenti di blocco, ansia o cambiamento e migliorare la qualità della vita.",
    icon: "brain",
    subs: [
      {
        title: "Percorso Individuale",
        text: "Ti accompagno in uno spazio sicuro e privo di giudizio per esplorare le tue emozioni, affrontare vissuti dolorosi, gestire lo stress e sviluppare una maggiore autostima.",
      },
      {
        title: "Percorso di Coppia",
        text: "Dedicato alle coppie che attraversano periodi di crisi, incomprensioni, cambiamenti importanti o sofferenza relazionale. Lavoriamo insieme per ricostruire la fiducia, comprendere i bisogni reciproci e ritrovare l'armonia.",
      },
    ],
  },
  {
    key: "consulenza-sessuale",
    title: "Sessuologia",
    desc: "La sessualità e l'intimità sono componenti essenziali del benessere personale e di coppia. Attraverso la consulenza sessuologica affrontiamo blocchi emotivi, dubbi, difficoltà prestazionali o cali del desiderio.",
    icon: "heart-handshake",
    subs: [
      {
        title: "Incontro Individuale",
        text: "Un percorso riservato per esplorare la propria sessualità, superare ansie da prestazione, disfunzioni o blocchi psicologici e vivere l'intimità in modo libero e consapevole.",
      },
      {
        title: "Incontro di Coppia",
        text: "Pensato per le coppie che desiderano ritrovare l'intesa sessuale, superare periodi di stallo o incomunicabilità nella sfera intima e riscoprire la complicità e il piacere condiviso.",
      },
    ],
  },
  {
    key: "ipnosi",
    title: "Comunicazione Ipnotica",
    desc: "Sessioni basate sulla comunicazione ipnotica per ridurre lo stress, migliorare il sonno e ritrovare un profondo equilibrio interiore.",
    icon: "moon",
  },
];
